<template>
  <div>
    <b-modal ref="createOrderItemModal"
             :title="title" :no-close-on-backdrop="true">
      <b-form-checkbox class="activity-holder" v-model="orderItemData.activity">
        {{$t('labels.common.activity')}}
      </b-form-checkbox>
      <b-row v-if="isNewItem">
        <b-col cols="4">
          <label>{{$t('labels.common.smart_search')}}</label>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="11">
          <input class="form-control" v-model="searchData.text"
                 :disabled="isSmartSearchDisabled"
                 @keyup.enter="searchLot" :tabindex="1" placeholder="">
        </b-col>
        <b-col>
          <img src="@/assets/images/common-icons/icon_search.svg" @click="searchLot" height="20"
               :tabindex="2"
               :title="$t('buttons.common.search')">
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>{{$t('labels.lots.lot_and_price')}}</label>
          <multiselect v-model="orderItemData.lot" :max-height="200" :tabindex="3"
                       placeholder="" label="description" track-by="id" :options="lotsForSelect"
                       :disabled="!isActiveOrderItem || orderItemData.related_packages_exist"
                       :show-labels="false"
                       @select="autoComplete"
                       :class="{ required: (!orderItemData.lot) }"
                       :taggable="true" :close-on-select="true"></multiselect>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>{{$t('labels.common.wood')}}</label>
        </b-col>
        <b-col>
          <label>{{$t('labels.common.quality')}}</label>
        </b-col>
        <b-col>
          <label>{{$t('labels.common.humidity')}}</label>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <multiselect v-model="orderItemData.wood" :max-height="200" :tabindex="5"
                       placeholder="" label="name" track-by="id" :options="wood"
                       :show-labels="false"
                       :disabled="!isActiveOrderItem || orderItemData.related_packages_exist"
                       :class="{ required: (!orderItemData.wood || orderItemData.wood.length === 0) }"
                       :taggable="true" :close-on-select="true"></multiselect>
        </b-col>
        <b-col>
          <multiselect v-model="orderItemData.qualities" :max-height="200" :tabindex="6"
                       placeholder="" label="name" track-by="id" :options="qualities_list"
                       :show-labels="false" :multiple="priceUsageIsPriceList"
                       :disabled="!isActiveOrderItem || orderItemData.related_packages_exist"
                       :class="{ required: (!orderItemData.qualities || orderItemData.qualities.length === 0) }"
                       taggable close-on-select></multiselect>
        </b-col>
        <b-col>
          <multiselect v-model="orderItemData.humidities" :max-height="200" :tabindex="7"
                       placeholder="" :options="humidity_list"
                       :show-labels="false" :multiple="priceUsageIsPriceList"
                       :disabled="!isActiveOrderItem || orderItemData.related_packages_exist"
                       :class="{ required: (!orderItemData.humidities || orderItemData.humidities.length === 0) }"
                       :taggable="true" :close-on-select="true"></multiselect>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>{{$t('labels.purchase_orders.profile')}}</label>
        </b-col>
        <b-col>
          <label>{{$t('labels.common.delivery_date')}}</label>
        </b-col>
        <b-col>
          <label>{{$t('labels.purchase_orders.sale_order_nr')}}</label>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <multiselect v-if="priceUsageIsPriceList" v-model="orderItemData.profiles" :max-height="200" :tabindex="8"
                       placeholder="" label="name" track-by="id" :options="profiles"
                       :show-labels="false" multiple
                       :disabled="!isActiveOrderItem || orderItemData.related_packages_exist"
                       taggable close-on-select></multiselect>
          <multiselect v-else v-model="orderItemData.profiles" :max-height="200" :tabindex="8"
                       placeholder="" label="name" track-by="id" :options="profiles"
                       :show-labels="false"
                       :disabled="!isActiveOrderItem || orderItemData.related_packages_exist"
                       taggable close-on-select></multiselect>
        </b-col>
        <b-col>
          <datepicker v-model="orderItemData.delivery_term" lang="en" :first-day-of-week="1" :tabindex="9"
                      placeholder=""
                      :class="{ required: (!orderItemData.delivery_term) }"
          ></datepicker>
        </b-col>
        <b-col>
          <multiselect v-model="orderItemData.sales_order" :max-height="200" :tabindex="10"
                       placeholder="" label="descriptor" track-by="id"
                       :options="plainSalesOrders"
                       :show-labels="false"
                       :disabled="!isActiveOrderItem || orderItemData.related_packages_exist"
                       :taggable="true" :close-on-select="true"></multiselect>
        </b-col>
      </b-row>
      <b-row>
        <b-col class="d-flex justify-content-center">
          {{$t('labels.common.nominal')}}
        </b-col>
        <b-col class="d-flex justify-content-center">
          {{$t('labels.common.real')}}
        </b-col>
        <b-col class="d-flex justify-content-center">
          {{$t('labels.common.stock')}}
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="4">
          <label>{{$t('labels.common.thickness')}}</label>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <input class="form-control" v-model="orderItemData.thickness_nominal"
                 :tabindex="11" :disabled="!isActiveOrderItem || orderItemData.related_packages_exist"
                 :class="{ required: (!orderItemData.thickness_nominal) }"
                 placeholder="">
        </b-col>
        <b-col>
          <input class="form-control" v-model="orderItemData.thickness_actual"
                 :tabindex="14" :disabled="!isActiveOrderItem || orderItemData.related_packages_exist"
                 placeholder="">
        </b-col>
        <b-col>
          <input class="form-control" v-model="orderItemData.thickness_stock"
                 :tabindex="17" :disabled="!isActiveOrderItem || orderItemData.related_packages_exist"
                 placeholder="">
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="4">
          <label>{{$t('labels.common.width')}}</label>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <input class="form-control" v-model="orderItemData.width_nominal"
                 :tabindex="12" :disabled="!isActiveOrderItem || orderItemData.related_packages_exist"
                 :class="{ required: (!orderItemData.width_nominal) }"
                 placeholder="">
        </b-col>
        <b-col>
          <input class="form-control" v-model="orderItemData.width_actual"
                 :tabindex="15" :disabled="!isActiveOrderItem || orderItemData.related_packages_exist"
                 placeholder="">
        </b-col>
        <b-col>
          <input class="form-control" v-model="orderItemData.width_stock"
                 :tabindex="18" :disabled="!isActiveOrderItem || orderItemData.related_packages_exist"
                 placeholder="">
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="4">
          <label>{{$t('labels.common.length')}}</label>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <input class="form-control" v-model="orderItemData.length_nominal" @input="autoCompleteLength"
                 :tabindex="13" :disabled="!isActiveOrderItem || orderItemData.related_packages_exist"
                 :class="{ required: (!orderItemData.length_nominal) }"
                 placeholder="">
        </b-col>
        <b-col>
          <input class="form-control" v-model="orderItemData.length_actual"
                 :tabindex="16" :disabled="!isActiveOrderItem || orderItemData.related_packages_exist"
                 placeholder="">
        </b-col>
        <b-col>
          <input class="form-control" v-model="orderItemData.length_stock"
                 :tabindex="19" :disabled="!isActiveOrderItem || orderItemData.related_packages_exist"
                 placeholder="">
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="4">
          <label>{{$t('labels.common.ordered')}}</label>
        </b-col>
        <b-col cols="4">
        </b-col>
        <b-col cols="4">
          <label>{{$t('labels.lots.lot_spec_balance')}}</label>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <input class="form-control" v-model="orderItemData.amount" :tabindex="20"
                 v-digits-after-decimal="{numberOfDigits: 3}"
                 :disabled="!isActiveOrderItem || orderItemData.related_packages_exist"
                 :class="{ required: (!orderItemData.amount) }"
                 placeholder="">
        </b-col>
        <b-col>
          <multiselect v-model="orderItemData.measure_type" :max-height="200" :tabindex="21"
                       placeholder="" :options="measure_types"
                       :show-labels="false"
                       :disabled="!isActiveOrderItem || orderItemData.related_packages_exist"
                       :class="{ required: (!orderItemData.measure_type || orderItemData.measure_type.length === 0) }"
                       :taggable="true" :close-on-select="true"></multiselect>
        </b-col>
        <b-col>
          <input class="form-control" v-model="orderItemData.diff" :disabled="true">
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>{{$t('labels.purchase_orders.product_type')}}</label>
          <multiselect v-model="orderItemData.m3_formula" :max-height="200" :tabindex="22"
                       placeholder="" label="name" track-by="key" :options="shapeType"
                       :show-labels="false"
                       :disabled="!isActiveOrderItem || orderItemData.related_packages_exist"
                       :class="{ required: (!orderItemData.m3_formula || orderItemData.m3_formula.length === 0) }"
                       :taggable="true" :close-on-select="true"></multiselect>
        </b-col>
        <b-col>
          <label>{{$t('labels.common.pricePerm3')}}</label>
          <input class="form-control" v-model="orderItemData.price_per_unit" :tabindex="23"
                 v-digits-after-decimal="{numberOfDigits: 2}"
                 :disabled="!isActiveOrderItem || orderItemData.related_packages_exist"
                 :class="{ required: (!orderItemData.price_per_unit) }"
                 placeholder="">
        </b-col>
        <b-col>
          <label>{{$t('labels.common.currency')}}</label>
          <input class="form-control" v-model="orderItemData.currency" :disabled="true">
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>{{$t('labels.purchase_orders.purpose')}}</label>
        </b-col>
        <b-col>
          <label>{{$t('labels.purchase_orders.quantity_packets')}}</label>
        </b-col>
        <b-col>
          <label>{{$t('labels.purchase_orders.peace_per_package')}}</label>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <multiselect v-model="orderItemData.purpose" :max-height="200" :tabindex="24"
                       placeholder="" label="name" track-by="key" :options="purposes"
                       :show-labels="false"
                       :disabled="!isActiveOrderItem || orderItemData.related_packages_exist"
                       :taggable="true" :close-on-select="true"></multiselect>
        </b-col>
        <b-col>
          <input class="form-control" v-model="orderItemData.number_of_packages"
                 v-replace-with-positive
                 :disabled="!isActiveOrderItem || orderItemData.related_packages_exist" :tabindex="25"
                 placeholder="">
        </b-col>
        <b-col>
          <input class="form-control" v-model="orderItemData.package_size"
                 v-replace-with-positive
                 :disabled="!isActiveOrderItem || orderItemData.related_packages_exist" :tabindex="26"
                 placeholder="">
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <label>{{$t('labels.purchase_orders.pack_descr')}}</label>
        </b-col>
        <b-col>
          <label>{{$t('labels.purchase_orders.quality_desc')}}</label>
        </b-col>
        <b-col>
          <label>{{$t('labels.common.notes')}}</label>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <multiselect v-model="orderItemData.baling" :max-height="200" :tabindex="27"
                       placeholder="" label="name" track-by="id"
                       :options="packageDescriptions"
                       :show-labels="false"
                       :disabled="!isActiveOrderItem || orderItemData.related_packages_exist"
                       :taggable="true" :close-on-select="true"></multiselect>
        </b-col>
        <b-col>
          <multiselect v-model="orderItemData.quality_desc" :max-height="200" :tabindex="28"
                       placeholder="" label="name" track-by="id" :options="qualityDesc"
                       :show-labels="false"
                       :disabled="!isActiveOrderItem || orderItemData.related_packages_exist"
                       :taggable="true" :close-on-select="true"></multiselect>
        </b-col>
        <b-col>
          <b-form-textarea
            :disabled="!isActiveOrderItem || orderItemData.related_packages_exist"
            v-model="orderItemData.notes"
            :tabindex="29"
            placeholder="">
          </b-form-textarea>
        </b-col>
      </b-row>
      <div slot="modal-footer" class="w-100 text-right">
        <span v-if="orderItemData.related_packages_exist" class="red-text">You can not edit PO item with related packages</span>
        <b-btn size="sm" variant="success" @click="saveItem('save')"
               :disabled="!isActiveOrderItem || orderItemData.related_packages_exist">
          {{$t('buttons.common.save')}}
        </b-btn>
        <b-btn size="sm" variant="success" @click="saveItem('add_another')">
          {{$t('buttons.common.save_add_more')}}
        </b-btn>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import Multiselect from 'vue-multiselect';
  import Datepicker from 'vue2-datepicker';
  import { mapState } from 'vuex';
  import moment from 'moment';
  import {
    handlerResponse,
    setNotifyData
  } from '@/helpers/commonHelpers';
  import { notificationsRenderer } from '@/helpers/renderHelpers';
  import { DATE_FORMAT } from '@/constants';
  import { getArrayByProperty } from '@/helpers/commonHelpers'

  export default {
    props: {
      purchaseOrderID: {
        type: String,
        default: () => ''
      },
      supplier: {
        type: [String, Object],
        default: () => ({})
      }
    },
    components: {
      Multiselect,
      Datepicker
    },
    data() {
      return {
        showCollapse: false,
        isNewItem: true,
        width_limit: '',
        length_limit: '',
        thickness_limit: '',
        lotsForSelect: [],
        orderItemData: {
          activity: true,
          lot: '',
          wood: [],
          thickness_nominal: null,
          thickness_actual: null,
          thickness_stock: null,
          width_nominal: null,
          width_actual: null,
          width_stock: null,
          length_nominal: null,
          length_actual: null,
          length_stock: null,
          quality: '',
          purpose: null,
          humidities: '',
          measure_type: '',
          amount: '',
          price_per_unit: '',
          currency: '',
          package_size: null,
          number_of_packages: null,
          diff: '',
          baling: '',
          quality_desc: '',
          delivery_term: '',
          notes: '',
          profile_desc: '',
          m3_formula: {key: 'm3_common', name: 'sawn/planed timber'},
          sales_order: '',
          related_packages_exist: false
        },
        searchData: {
          text: '',
          status: 'active'
        }
      }
    },
    watch: {
      async 'orderItemData.activity' (value) {
        try {
          if (this.orderItemData.id) {
            const { data: { activity } } = await this.$http.post(`purchase/order_items/${this.orderItemData.id}/`, {
              activity: value
            })
            this.$set(this.orderItemData, 'activity', activity)
          }
        } catch (e) {
          console.log(e)
        }
      }
    },
    methods: {
      /**
       * function for array filling items depend price usage
       * This method is deprecated as purchase_price is now outdated
       * @param idKey - key for single item
       * @returns {*|*[]|string} - new data that comes to payload
       */
      getItemsDependOnPriceUsage (idKey) {
        let item = this.orderItemData[idKey]
        const isHumidities = idKey === 'humidities'

        if (this.priceUsageIsPriceList) {
          if (isHumidities) { // humidity is id-less items, we have to use it as it
            return item
          }
          // getting ids of current items or empty array
          return item.length ? getArrayByProperty(item, 'id') : []
        }
        // humidity is a weird case. from backends it comes as array anyway,
        // but when you choose it in non-multiselect it will eventually be just integer
        // as payload info it needs to be converted to "[Integer]" type
        if (isHumidities) {
          item = Array.isArray(item) ? item : [item]
        }
        // we still need to pass array, but with one item
        return item ? isHumidities ? item : [item.id] : []
      },
      refreshOrderItemData (response) {
        const bufferLotOrPrice = this.orderItemData.lot
        this.orderItemData = { ...this.orderItemData, ...response, lot: bufferLotOrPrice };
        if (!this.priceUsageIsPriceList) {
          this.orderItemData = {
            ...this.orderItemData,
            qualities: response.qualities[0],
            humidities: response.humidities[0],
            profiles: response.profiles[0]
          }
        }
      },
      async saveItem(actionType) {
        const loader = this.$loading.show()
        const priceOrLotKey = this.priceUsageIsPriceList ? 'price' : 'lot'
        const clearKey = this.priceUsageIsPriceList ? 'lot' : 'price'
        const saveData = {
          ...this.orderItemData,
          purchase_order: this.purchaseOrderID,
          amount: this.orderItemData.amount,
          [priceOrLotKey]: this.orderItemData.lot ? this.orderItemData.lot.id : null,
          [clearKey]: null,
          // lot: this.orderItemData.lot ? this.orderItemData.lot.id : null,
          qualities: this.getItemsDependOnPriceUsage('qualities'),
          humidities: this.getItemsDependOnPriceUsage('humidities'),
          profiles: this.getItemsDependOnPriceUsage('profiles'),
          m3_formula: this.orderItemData.m3_formula ? this.orderItemData.m3_formula.key : null,
          wood: this.orderItemData.wood ? this.orderItemData.wood.id : '',
          quality_desc: this.orderItemData.quality_desc ? this.orderItemData.quality_desc.id : '',
          baling: this.orderItemData.baling ? this.orderItemData.baling.id : '',
          delivery_term: this.orderItemData.delivery_term ? moment(this.orderItemData.delivery_term).format(DATE_FORMAT) : '',
          // profile_desc: this.orderItemData.profile_desc ? this.orderItemData.profile_desc.id : '',
          purpose: this.orderItemData.purpose ? this.orderItemData.purpose.key : '-',
          sales_order: this.orderItemData.sales_order ? this.orderItemData.sales_order.id : ''
        };
        if (this.checkTWL()) {
          if (this.isNewItem) {
            try {
              const response = await this.$http.post(`purchase/order_items/`, saveData).then(handlerResponse)
              this.$notify(setNotifyData('Success', 'Order item has been created!', 'success'));
              await this.$store.dispatch('purchaseOrderItems/loadOrderItems', {order_id: this.purchaseOrderID});
              this.$root.$emit('updatePurchaseOrderInfo', {id: this.purchaseOrderID});
              if (actionType === 'add_another') {
                this.refreshOrderItemData(response)
                this.cleanChangedParamsFromLot();
                this.$http.get(`purchase/${priceOrLotKey}s/${this.orderItemData[priceOrLotKey].id}/`).then(handlerResponse).then((response) => {
                  this.orderItemData.diff = response.diff;
                });
              } else if (actionType === 'update_and_add') {
                this.refreshOrderItemData(response)
                this.cleanChangedParamsFromLot();
                this.isNewItem = false;
              } else {
                this.$refs['createOrderItemModal'].hide();
              }
            } catch (error) {
              console.log(error);
              notificationsRenderer(error.body, 'error');
            }
          } else {
            try {
              await this.$http.put(`purchase/order_items/${this.orderItemData.id}/`, saveData).then(handlerResponse)
              this.$notify(setNotifyData('Success', 'Order item has been saved!', 'success'));
              await this.$store.dispatch('purchaseOrderItems/loadOrderItems', {order_id: this.purchaseOrderID});
              this.$root.$emit('updatePurchaseOrderInfo', {id: this.purchaseOrderID});
              if (actionType === 'add_another') {
                this.isNewItem = true;
                await this.saveItem('update_and_add');
              } else {
                this.$refs['createOrderItemModal'].hide();
              }
            } catch (error) {
              console.log(error);
              notificationsRenderer(error.body, 'error');
            }
          }
        }
        loader.hide()
      },
      cleanChangedParamsFromLot() {
        this.orderItemData.length_nominal = '';
        this.orderItemData.length_actual = '';
        this.orderItemData.length_stock = '';
        this.orderItemData.amount = 0;
      },
      searchLot(payload) {
        this.searchData = {
          ...this.searchData,
          shipper: this.searchData.text
        }
        this.$http.get(`purchase/${this.lotsOrPrices}/search_by_description/`, {params: this.searchData})
          .then(handlerResponse).then((response) => {
            this.lotsForSelect = response;
            if (payload) {
              const item = this.lotsForSelect.find((el) => {
                return el.id === payload[this.priceUsageIsPriceList ? 'price' : 'lot']?.id
              })
              this.$set(this.orderItemData, 'lot', item)
            }
          }).catch((error) => {
            console.log(error);
            notificationsRenderer(error.body, 'error');
          })
      },
      autoComplete(event) {
        const loader = this.$loading.show()
        this.$http.get(`purchase/${this.lotsOrPrices}/${event.id}/`).then(handlerResponse).then((response) => {
          delete response.delivery_term;
          delete response.amount;
          delete response.notes;
          delete response.id;
          this.orderItemData = {
            ...this.orderItemData,
            currency: response.currency_code,
            ...response,
            qualities: response.quality ? response.quality : response.qualities,
            humidities: response.humidity ? response.humidity : response.humidities
          }
          this.setLimits();
          loader.hide()
        });
      },
      autoCompleteLength() {
        this.orderItemData.length_actual = this.orderItemData.length_nominal;
        this.orderItemData.length_stock = this.orderItemData.length_nominal;
      },
      checkTWL() {
        if (Number(this.orderItemData.thickness_nominal) < Number(this.orderItemData.thickness_nominal_from) || Number(this.orderItemData.thickness_nominal) > Number(this.orderItemData.thickness_nominal_to) || !this.orderItemData.thickness_nominal) {
          this.$notify(setNotifyData('', 'Thickness is incorrect', 'error'));
          return false
        } else if (Number(this.orderItemData.width_nominal) < Number(this.orderItemData.width_nominal_from) || Number(this.orderItemData.width_nominal) > Number(this.orderItemData.width_nominal_to) || !this.orderItemData.width_nominal) {
          this.$notify(setNotifyData('', 'Width is incorrect', 'error'));
          return false
        } else if (Number(this.orderItemData.length_nominal) < Number(this.orderItemData.length_nominal_from) || Number(this.orderItemData.length_nominal) > Number(this.orderItemData.length_nominal_to) || !this.orderItemData.length_nominal) {
          this.$notify(setNotifyData('', 'Length is incorrect', 'error'));
          return false
        } else {
          return true
        }
      },
      setLimits() {
        if (this.orderItemData.length_nominal_from !== '' && this.orderItemData.width_nominal_from !== '' && this.orderItemData.thickness_nominal_from !== ''
          && this.orderItemData.length_nominal_to && this.orderItemData.width_nominal_to && this.orderItemData.thickness_nominal_to) {
          this.length_limit = `from ${this.orderItemData.length_nominal_from} to  ${this.orderItemData.length_nominal_to} `;
          this.width_limit = `from ${this.orderItemData.width_nominal_from} to ${this.orderItemData.width_nominal_to} `;
          this.thickness_limit = `from ${this.orderItemData.thickness_nominal_from} to ${this.orderItemData.thickness_nominal_to} `;
        } else {
          this.width_limit = '';
          this.length_limit = '';
          this.thickness_limit = '';
        }
      },
      setDefaults() {
        //set default Quality as "синева до 15%"
        this.orderItemData.quality_desc = this.qualityDesc.find(e => e.id === 2);
        //set default Product type as sawn/plane timber
        this.orderItemData.m3_formula = this.shapeType.find(e => e.key === 'm3_common');
      }
    },
    async beforeMount() {
      await this.$store.cache.dispatch('woodware/getWood');
      await this.$store.cache.dispatch('woodware/getQualitiesList');
      await this.$store.cache.dispatch('woodware/getProfiles');
      await this.$store.cache.dispatch('woodware/loadHumidityList');
      await this.$store.dispatch('purchaseOrderItems/loadPurposes');
      await this.$store.dispatch('purchaseOrderItems/loadPackageDescriptions');
      await this.$store.dispatch('salesOrders/loadPlainSalesOrders');
      await this.$store.cache.dispatch('generic/loadShapeType');
      await this.$store.dispatch('purchaseOrderItems/loadQualityDescriptions');
      this.setDefaults();
    },
    mounted() {
      this.$root.$on('openCreateOrderItemModal', async (payload) => {
        if (this.$refs['createOrderItemModal']) {
          this.isNewItem = payload.isNewItem;
          this.orderItemData = { ...payload };
          if (!payload.hasOwnProperty('activity')) {
            this.$set(this.orderItemData, 'activity', true)
          }
          this.setLimits();
          if (this.isNewItem) {
            this.setDefaults();
          }
          await this.searchLot(payload);
          this.$refs['createOrderItemModal'].show();
        }
      })
    },
    beforeDestroy() {
      this.$root.$off('openCreateOrderItemModal');
    },
    computed: {
      ...mapState('woodware', ['wood', 'qualities_list', 'measure_types', 'profiles', 'humidity_list']),
      ...mapState('generic', ['shapeType']),
      ...mapState('purchaseOrderItems', ['packageDescriptions', 'qualityDesc', 'purposes']),
      ...mapState('salesOrders', ['plainSalesOrders']),
      title() {
        return this.isNewItem ? `${this.$i18n.t('modal_dialogs.purchase_order_item.add_order_item')}` : `${this.$i18n.t('modal_dialogs.purchase_order_item.edit_order_item')}`;
      },
      priceUsage () {
        return this.supplier?.price_usage
      },
      lotsOrPrices () {
        return this.priceUsage === 'price_list' ? 'prices' : 'lots'
      },
      isActiveOrderItem() {
        return Boolean(this.orderItemData.status === 'active' || this.isNewItem)
      },
      priceUsageIsPriceList () {
        return this.supplier.price_usage === 'price_list'
      },
      isSmartSearchDisabled () {
        return !this.isActiveOrderItem || this.orderItemData.related_packages_exist || this.priceUsageIsPriceList
      }
    }
  }
</script>
<style lang="sass">
.activity-holder
  position: absolute
  top: -40px
  label
    line-height: 1.8

</style>



// WEBPACK FOOTER //
// src/components/modals/PurchaseOrderItemModal.vue